import styled from "styled-components";

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid #ececec;
  border-radius: 8px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;
`;

export const THead = styled.thead`
  background: #f7f9fb;
`;

export const TH = styled.th`
  text-align: left;
  padding: 16px;
  color: #525252;
  font-size: 13px;
  text-transform: uppercase;
`;

export const TD = styled.td`
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  color: #1a1a1a;
  font-size: 14px;
  vertical-align: middle;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: ${({ active }) => (active ? "#0f6b38" : "#666666")};
  background: ${({ active }) => (active ? "#d9f6e6" : "#ececec")};
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :hover {
    background: #f7f9fb;
  }
`;

export const ActionIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const EmptyState = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: #707070;
`;
